import React from 'react';
import logo from './logo.svg';
import './App.css';
import Playground from './components/Playground'

const App = () => <Playground />

export default App;
